import React from "react";
import { useReveal } from "@/hooks/useReveal";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { trackEvent } from "@/lib/analytics";

const ITEMS = [
  { k: "i", t: "Pequenos grupos", d: "Até seis pessoas por aula, para um ritmo respirado." },
  { k: "ii", t: "Acompanhamento próximo", d: "Escuta atenta, correções subtis, presença real." },
  { k: "iii", t: "Movimento consciente", d: "Cada exercício adaptado ao corpo que está presente." },
  { k: "iv", t: "Atenção individual", d: "Para que ninguém se sinta apenas mais um número." },
];

export default function Trial() {
  const ref = useReveal();

  return (
    <section
      id="experimental"
      ref={ref}
      className="relative bg-[var(--luft-bg-alt)] py-32 sm:py-44 lg:py-52"
      data-testid="trial-section"
    >
      <div className="max-w-[1100px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="text-center max-w-3xl mx-auto reveal">
          <p className="eyebrow mb-10">08 — Primeira experiência no Lu.ft</p>
          <h2
            className="editorial-heading text-[clamp(2rem,5vw,4rem)] text-[var(--luft-ink)]"
            data-testid="trial-title"
          >
            Venha conhecer-nos.<br />
            A primeira aula é um <em className="editorial-italic">convite</em>.
          </h2>
          <p
            className="mt-10 font-body font-light text-[var(--luft-ink-soft)] text-base leading-relaxed max-w-xl mx-auto"
            data-testid="trial-description"
          >
            Acreditamos numa prática pensada para cada pessoa. Aqui não há multidões,
            nem pressas — apenas o seu corpo, o seu ritmo, e a nossa atenção.
          </p>
        </div>

        <div className="mt-20 grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-10 max-w-2xl mx-auto reveal">
          {ITEMS.map((it) => (
            <div key={it.k} className="border-t border-[var(--luft-line)] pt-5">
              <div className="flex items-baseline gap-4">
                <span className="font-display italic text-[var(--luft-blue)] text-xl">{it.k}</span>
                <h3 className="font-display text-2xl text-[var(--luft-ink)]">{it.t}</h3>
              </div>
              <p className="mt-3 ml-8 font-body font-light text-[var(--luft-ink-soft)] text-sm leading-relaxed">
                {it.d}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-20 flex justify-center reveal">
          <Link
            to="/reservar"
            className="btn-ink"
            data-testid="trial-reservar-btn"
            onClick={() => trackEvent("reservar_click", { cta_location: "trial" })}
          >
            Reservar primeira aula
            <ArrowRight size={14} strokeWidth={1.4} />
          </Link>
        </div>
      </div>
    </section>
  );
}
